<template lang="pug">
    SspLayout.tree-revision-list(area="tnt")
      template(slot="actions")
        button.btn.btn-default.refresh.button(@click="$refs.pagination.reload()")
          i.fa.fa-refresh
      i.center-loader.fa.fa-spinner.fa-pulse.fa-spin.fa-4x(v-if="rootsLoading")
      GenericTable(ref="grid" :loading="loadingList")
        tr(slot="thead")
          th Id
          th Size
          th Creator
          th Created
        tr.clickable(:key="index" v-for="(r, index) in revisions" @click="expandTree(r.id)")
          td {{r.id}}
          td {{r.codeCount}}
          td {{r.creator.username}}
          td {{r.created | date}}
      IndefinitePagination(ref="pagination" :fetch="fetchData" urlPageParam="offset")

      TreeRootModal(ref="treeRootModal")
</template>

<script>
import GenericTable from '@/components/common/GenericTable'
import IndefinitePagination from '@/components/common/IndefinitePagination'
import TrackNTrace from '@/service/apis/TrackNTrace'
import { dateFilter } from '@/filters/filters'
import TreeRootModal from './TreeRootsModal'

export default {
  data: () => ({
    rootsLoading: false,
    roots: null,
    revisions: null,
    loadingList: false,
    loadingExpansion: false
  }),
  methods: {
    fetchData(req) {
      this.loadingList = true
      return TrackNTrace.listRevisionTrees(req)
        .then((resp) => {
          this.revisions = resp.data.revisions.revision
          return resp.data.hasMore
        })
        .catch((e) => { this.$emit('error', e) })
        .then((hasMore) => {
          this.loadingList = false
          return hasMore
        })
    },
    expandTree(id) {
      this.rootsLoading = true
      TrackNTrace.viewTreeRoots(id)
        .then((resp) => resp.data.roots.package)
        .then((roots) => {
          this.rootsLoading = false
          this.$refs.treeRootModal.open(roots)
        })
    }
  },
  components: {
    GenericTable,
    IndefinitePagination,
    TreeRootModal
  },
  filters: {
    date: dateFilter
  }
}
</script>

<style lang="scss">
.tree-revision-list {
  th {
    width: 25%;
  }
  .center-loader {
    position: absolute;
    top: 30%;
    left: 50%;
    z-index: 1000;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/pages/trackntrace/dashboards/treerevision/TreeRevisionList.vue